import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { APP_VERSION_UPDATED_SESSION_KEY, VersionCheckService } from './version-check.service';

function isChunkLoadError(error: unknown): boolean {
  if (error && typeof error === 'object' && 'name' in error && (error as Error).name === 'ChunkLoadError') {
    return true;
  }
  const msg = error instanceof Error ? error.message : String(error);
  return /Loading chunk \d+ failed/i.test(msg)
    || /Failed to fetch dynamically imported module/i.test(msg)
    || /error loading dynamically imported module/i.test(msg);
}

@Injectable()
export class ChunkLoadDelegatingErrorHandler implements ErrorHandler {
  private readonly sentryHandler = Sentry.createErrorHandler();
  private readonly versionCheck = inject(VersionCheckService);

  handleError(error: unknown): void {
    if (typeof window !== 'undefined' && isChunkLoadError(error)) {
      try {
        sessionStorage.setItem(APP_VERSION_UPDATED_SESSION_KEY, '1');
      } catch {
        // ignore
      }
      const target = this.versionCheck.lastNavigationTargetUrl
        ?? `${window.location.pathname}${window.location.search}`;
      window.location.assign(target);
      return;
    }
    this.sentryHandler.handleError(error);
  }
}
